<div id="dms" class="dms" *ngIf="isBrowser()">
    <div class="btn-toolbar dms-toolbar">
        <div
            class="btn-group"
            role="group"
            *ngIf="!standard.simpleView"
            #mainMenu
        >
            <div class="dropdown">
                <button
                    class="btn btn-primary dropdown-toggle"
                    type="button"
                    id="dropdownActionMenu"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                    Actions
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownActionMenu">
                    <input
                        type="button"
                        [attr.data-bs-toggle]="'modal'"
                        [attr.data-bs-target]="'#add-url'"
                        value="Add URL"
                        class="dropdown-item"
                        (click)="hideMenus()"
                    />
                    <input
                        type="button"
                        value="Create Folder"
                        (click)="
                            createFolder(standard.currentFolder, null, true)
                        "
                        class="dropdown-item"
                    />
                    <span
                        class="dropdown-fileUpload dropdown-item"
                        (click)="hideMenus()"
                        ><p-fileUpload
                            mode="basic"
                            class="dropdown-text-override dropdown-fileUpload dropdown-item dms-fileUpload dark-text"
                            name="files[]"
                            [url]="uploadPath()"
                            [accept]="standard.accept"
                            [multiple]="true"
                            [auto]="true"
                            chooseLabel="Upload File"
                            customUpload="true"
                            #fileUploader
                            (onError)="uploadError($event)"
                            (uploadHandler)="uploadHandler($event)"
                        ></p-fileUpload
                    ></span>
                    <span
                        class="dropdown-text-override dropdown-item ui-button ui-fileupload-choose ui-widget ui-state-default ui-corner-all ui-button-text-icon-left position-relative"
                        (click)="hideMenus()"
                    >
                        Upload Folder
                        <input
                            #folderInput
                            type="file"
                            webkitDirectory
                            [disabled]="uploadFolderDisabled"
                            (change)="folderPicked(folderInput.files)"
                        />
                    </span>
                    <div class="dropdown-item">
                        <div
                            class="btn-group dropright dropdown-text-margin"
                            #subMenu
                        >
                            <div class="mb-3 form-check">
                                <input
                                    type="checkbox"
                                    class="form-check-input mt-2 dropdown-checkbox"
                                    id="enableMultiSelect"
                                    [(ngModel)]="isMultiSelect"
                                    (change)="
                                        isMultiSelectChanged(isMultiSelect)
                                    "
                                />
                                <label
                                    class="form-check-label"
                                    for="enableMultiSelect"
                                    >Enable Multi-Select</label
                                >
                            </div>
                            <div class="dropright">
                                <button
                                    type="button"
                                    class="dropdown-toggle p-0 px-2 line-height-20"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    (click)="toggleMultiSelectDropdown($event)"
                                >
                                    <span class="fa fa-caret-right"></span>
                                </button>
                                <div class="dropdown-menu" #multiSelectDropdown>
                                    <input
                                        type="button"
                                        [disabled]="
                                            !isMultiSelect ||
                                            (selectedFile || []).length == 0
                                        "
                                        value="Copy"
                                        class="btn btn-link dropdown-item"
                                        (click)="showCopyMoveModal(true, true)"
                                    />
                                    <input
                                        type="button"
                                        [disabled]="
                                            !isMultiSelect ||
                                            (selectedFile || []).length == 0
                                        "
                                        value="Move"
                                        class="btn btn-link dropdown-item"
                                        (click)="showCopyMoveModal(false, true)"
                                    />
                                    <input
                                        type="button"
                                        [disabled]="
                                            !isMultiSelect ||
                                            (selectedFile || []).length == 0
                                        "
                                        value="Delete"
                                        class="btn btn-link dropdown-item"
                                        (click)="deleteFiles()"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="btn-group"
            *ngIf="standard.simpleView && standard.uploadFilesAllowed"
        >
            <p-fileUpload
                mode="basic"
                name="files[]"
                class="dark-text"
                [url]="uploadPath()"
                [accept]="standard.accept"
                [multiple]="true"
                [auto]="true"
                chooseLabel="Upload File"
                customUpload="true"
                (onError)="uploadError($event)"
                (uploadHandler)="uploadHandler($event)"
            ></p-fileUpload>
        </div>
        <div
            class="input-group ms-2"
            [ngClass]="standard.simpleView ? 'simple-view' : ''"
        >
            <div class="input-group-btn">
                <button
                    class="col-12 btn btn-primary"
                    (click)="search(false, $event)"
                    type="button"
                >
                    <fa-icon [icon]="faSearch"></fa-icon>
                </button>
            </div>
            <input
                [(ngModel)]="standard.filter"
                type="text"
                (keyup.enter)="search(false, $event)"
                class="form-control editable-tree-node"
                title=""
                (keydown.enter)="$event.preventDefault()"
            />
            <p-multiSelect
                [options]="hideableColumns"
                [(ngModel)]="selectedColumns"
                class="dms-dropdown hidden-xxs"
                [styleClass]="'form-control p-0 pt-10'"
                [resetFilterOnHide]="true"
                [autofocusFilter]="false"
                [showClear]="false"
                [maxSelectedLabels]="10000"
            ></p-multiSelect>
        </div>
    </div>
    <div class="clearfix"></div>
    <!-- Back and breadcrumbs -->
    <div class="btn-toolbar dms-toolbar">
        <div class="btn-group d-block">
            <button
                type="button"
                (click)="cancel(false)"
                class="btn btn-primary"
            >
                {{ standard.isSearching ? "Cancel" : "Clear" }}
            </button>
        </div>
        <div class="input-group breadcrumb-group ms-2">
            <button
                class="btn btn-primary"
                (click)="back(false)"
                type="button"
                [disabled]="standard.isTopLevel"
            >
                <fa-icon [icon]="faLeftArrow"></fa-icon>
            </button>
            <ng-container *ngFor="let breadcrumb of standard.breadcrumbs">
                <span
                    class="btn"
                    (click)="setSelectedFolderPath(breadcrumb, false)"
                >
                    <a class="display-inline cursor-pointer underline">{{
                        breadcrumb.name
                    }}</a>
                </span>
                <span class="dms-slash btn btn-link">/</span>
            </ng-container>
        </div>
    </div>

    <div class="clearfix"></div>
    <div class="row" *ngIf="!standard.simpleView">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
            <p>
                Please note that the following character is not allowed in any
                file/folder name: '/'
            </p>
        </div>
    </div>
    <!-- Main DMS Tree -->
        <div
            class="row file-tree {{ fileType }}"
            [ngClass]="'selection-mode-' + selectionMode"
            style="margin-left: 0; margin-right: 0"
        >
            <div
                class="col-xxs-12 border-1px-solid-top-left-right border-radius-0-bottom unselectable cursor-pointer p-0 d-flex align-items-center col-dms-label"
                [ngClass]="getLabelClass()"
                [style]="getNameColumnWidth()"
            >
                <div
                    *ngIf="isMultiSelect"
                    class="p-checkbox p-component dms-checkbox ms-2 me-2"
                    (click)="toggleSelectAll($event)"
                >
                    <div
                        class="p-checkbox-box"
                        [ngClass]="{
                            'p-highlight': selectAll
                        }"
                    >
                        <span
                            class="p-checkbox-icon pi"
                            [ngClass]="{
                                'pi-check': selectAll
                            }"
                        ></span>
                    </div>
                </div>

                <div class="mx-auto" (click)="sortBy('label', standard.files)">
                    Name
                    <fa-icon
                        *ngIf="showSortArrow('label')"
                        [icon]="getSortArrowClass()"
                    ></fa-icon>
                </div>
            </div>
            <div
                class="col-2 hidden-xxs border-1px-solid-top-left-right border-radius-0-bottom unselectable cursor-pointer"
                *ngIf="showColumn('modifiedBy')"
                (click)="sortBy('modifiedBy', standard.files)"
            >
                Modified By
                <fa-icon
                    *ngIf="showSortArrow('modifiedBy')"
                    [icon]="getSortArrowClass()"
                ></fa-icon>
            </div>
            <div
                class="col-2 hidden-xxs border-1px-solid-top-left-right border-radius-0-bottom unselectable cursor-pointer"
                *ngIf="showColumn('modifiedDate')"
                (click)="sortBy('modifiedDate', standard.files)"
            >
                Date Modified
                <fa-icon
                    *ngIf="showSortArrow('modifiedDate')"
                    [icon]="getSortArrowClass()"
                ></fa-icon>
            </div>
            <div
                class="col-1 hidden-xxs border-1px-solid-top-left-right border-radius-0-bottom unselectable cursor-pointer"
                *ngIf="showColumn('revisionNumber')"
                (click)="sortBy('revisionNumber', standard.files)"
            >
                PIMeo rev
                <fa-icon
                    *ngIf="showSortArrow('revisionNumber')"
                    [icon]="getSortArrowClass()"
                ></fa-icon>
            </div>
            <div
                class="col border-1px-solid-top-left-right border-radius-0-bottom unselectable cursor-pointer p-0 col-dms-options"
                [style]="getBlankColumnWidth()"
            >
                &nbsp;
            </div>
        </div>

    <span [ngClass]="getClassesForMainTree()">
        <p-tree
            class="dms-container"
            [value]="standard.files"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="droppedFile($event, node)"
            [selectionMode]="selectionMode"
            [contextMenu]="
                standard.simpleView || !allowContextMenu
                    ? null
                    : fileContextMenu
            "
            [(selection)]="selectedFile"
            (onNodeSelect)="nodeSelect($event, false, false)"
            (onNodeUnselect)="nodeUnselect($event)"
            (onNodeContextMenuSelect)="nodeSelect($event, true, false)"
            [loading]="standard.showLoading"
        >
            <ng-template let-node pTemplate="default">
                <span class="disable-selection">{{ node.label }}</span>
            </ng-template>

            <!-- Folder Template -->
            <ng-template let-node pTemplate="Folder">
                <div
                    class="dms-row-container"
                    (dragover)="onDragOver($event, node)"
                    (dragleave)="onDragLeave($event, node)"
                    (drop)="droppedFile($event, node)"
                >
                    <div class="row">
                        <div
                            class="col-xxs-12 col-dms-label"
                            [ngClass]="getLabelClass()"
                            [style]="getNameColumnWidth()"
                        >
                            {{ node.label }}
                        </div>
                        <div
                            *ngIf="showColumn('modifiedBy')"
                            class="col-2 hidden-xxs unselectable xs-no-margin modifiedBy-Line"
                        >
                            {{ node.data.modifiedBy }}
                        </div>
                        <div
                            *ngIf="showColumn('modifiedDate')"
                            class="col-2 hidden-xxs unselectable"
                        >
                            {{ node.data.modifiedDate | date : "yyyy-MM-dd" }}
                        </div>
                        <div
                            *ngIf="showColumn('revisionNumber')"
                            class="col-1 hidden-xxs unselectable"
                        >
                            {{ node.data.revisionNumber }}
                        </div>
                        <div
                            class="col unselectable cursor-pointer p-0 col-dms-options"
                            [style]="getBlankColumnWidth()"
                            *ngIf="allowContextMenu"
                        >
                            <button
                                class="btn option-btn btn-link dropdown-toggle"
                                type="button"
                                (contextmenu)="
                                    openCm($event, fileContextMenu, node)
                                "
                                (click)="openCm($event, fileContextMenu, node)"
                                (keyup.enter)="
                                    openCm($event, fileContextMenu, node)
                                "
                                [hidden]="isMultiSelect"
                            >
                                <span class="dot"></span>
                                <span class="dot"></span>
                                <span class="dot"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </ng-template>

            <!-- Image Template -->
            <ng-template let-node pTemplate="Image">
                <div
                    class="dms-row-container"
                    (dragover)="onDragOver($event, node)"
                    (dragleave)="onDragLeave($event, node)"
                    (drop)="droppedFile($event, node)"
                >
                    <div class="row">
                        <div
                            class="col-xxs-12 col-dms-label"
                            [ngClass]="getLabelClass()"
                            [style]="getNameColumnWidth()"
                        >
                            <span
                                pDraggable="true"
                                class="border image-container px-3 py-2 rounded-lg text-center thumbnail"
                            >
                                <img
                                    [src]="getColumnSrc(node.data)"
                                    target="_blank"
                                    title="{{ node.label }}"
                                />
                                <label
                                    class="fw-normal full-width text-start"
                                    >{{ node.label }}</label
                                >
                            </span>
                        </div>
                        <div
                            *ngIf="showColumn('modifiedBy')"
                            class="col-2 hidden-xxs unselectable xs-no-margin modifiedBy-Line"
                        >
                            {{ node.data.modifiedBy }}
                        </div>
                        <div
                            *ngIf="showColumn('modifiedDate')"
                            class="col-2 hidden-xxs unselectable"
                        >
                            {{ node.data.modifiedDate | date : "yyyy-MM-dd" }}
                        </div>
                        <div
                            *ngIf="showColumn('revisionNumber')"
                            class="col-1 hidden-xxs unselectable"
                        >
                            {{ node.data.revisionNumber }}
                        </div>
                        <div
                            class="col unselectable cursor-pointer p-0 col-dms-options"
                            [style]="getBlankColumnWidth()"
                            *ngIf="allowContextMenu"
                        >
                            <button
                                class="btn option-btn btn-link dropdown-toggle"
                                type="button"
                                (contextmenu)="
                                    openCm($event, fileContextMenu, node)
                                "
                                (click)="openCm($event, fileContextMenu, node)"
                                (keyup.enter)="
                                    openCm($event, fileContextMenu, node)
                                "
                                [hidden]="isMultiSelect"
                            >
                                <span class="dot"></span>
                                <span class="dot"></span>
                                <span class="dot"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </ng-template>

            <!-- File Template -->
            <ng-template let-node pTemplate="File">
                <div
                    class="dms-row-container"
                    (dragover)="onDragOver($event, node)"
                    (dragleave)="onDragLeave($event, node)"
                    (drop)="droppedFile($event, node)"
                >
                    <div class="row">
                        <div
                            class="col-xxs-12 col-dms-label"
                            [ngClass]="getLabelClass()"
                            [style]="getNameColumnWidth()"
                        >
                            {{ node.label }}
                        </div>
                        <div
                            *ngIf="showColumn('modifiedBy')"
                            class="col-2 hidden-xxs unselectable xs-no-margin modifiedBy-Line"
                        >
                            {{ node.data.modifiedBy }}
                        </div>
                        <div
                            *ngIf="showColumn('modifiedDate')"
                            class="col-2 hidden-xxs unselectable"
                        >
                            {{ node.data.modifiedDate | date : "yyyy-MM-dd" }}
                        </div>
                        <div
                            *ngIf="showColumn('revisionNumber')"
                            class="col-1 hidden-xxs unselectable"
                        >
                            {{ node.data.revisionNumber }}
                        </div>
                        <div
                            class="col unselectable cursor-pointer p-0 col-dms-options"
                            [style]="getBlankColumnWidth()"
                            *ngIf="allowContextMenu"
                        >
                            <button
                                class="btn option-btn btn-link dropdown-toggle"
                                type="button"
                                (contextmenu)="
                                    openCm($event, fileContextMenu, node)
                                "
                                (click)="openCm($event, fileContextMenu, node)"
                                (keyup.enter)="
                                    openCm($event, fileContextMenu, node)
                                "
                                [hidden]="isMultiSelect"
                            >
                                <span class="dot"></span>
                                <span class="dot"></span>
                                <span class="dot"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-tree>
    </span>
    <p-contextMenu
        class="hidden-mobile"
        appendTo="body"
        #fileContextMenu
        [model]="standard.contextMenu"
    ></p-contextMenu>

    <!-- Add URL Modal -->
    <div
        class="modal fade"
        id="add-url"
        tabindex="-1"
        role="dialog"
        *ngIf="!standard.simpleView"
    >
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>
                <div class="modal-body">
                    <h3>Add URL</h3>
                    <form (submit)="createUrl()">
                        <div class="row">
                            <label
                                for="url"
                                class="col-11 col-sm-11 col-md-3 col-lg-3"
                                >URL:</label
                            >
                            <input
                                id="url"
                                type="text"
                                name="url"
                                class="col-11 col-sm-11 col-md-8 col-lg-8"
                                [(ngModel)]="standard.urlLink"
                            />
                        </div>
                        <div class="clearfix"></div>
                        <input
                            type="submit"
                            class="btn btn-primary"
                            value="Add"
                        />
                    </form>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
    </div>

    <!-- Copy/Move File or Folder Modal Button -->
    <input
        type="button"
        #copyMoveModalButton
        [attr.data-bs-toggle]="'modal'"
        [attr.data-bs-target]="'#copy-move'"
        class="hidden"
    />

    <!-- Copy/Move File or Folder Modal -->
    <div
        class="modal fade"
        id="copy-move"
        tabindex="-1"
        role="dialog"
        *ngIf="!standard.simpleView"
    >
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">
                        {{ modal.isCopy ? "Copy" : "Move" }}
                    </h3>
                    <button
                        #copyMoveModalCloseButton
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>
                <div class="modal-body">
                    <!-- Clear and Search -->
                    <div class="btn-toolbar dms-toolbar">
                        <div class="input-group">
                            <div class="input-group-btn">
                                <button
                                    class="col-12 btn btn-primary"
                                    (click)="search(true, $event)"
                                    type="button"
                                >
                                    <fa-icon [icon]="faSearch"></fa-icon>
                                </button>
                            </div>
                            <input
                                [(ngModel)]="modal.filter"
                                type="text"
                                (keyup.enter)="search(true, $event)"
                                class="form-control editable-tree-node"
                            />
                        </div>
                    </div>
                    <div class="search-clarificaton">
                        Search will only search current folder. To search other
                        folders use breadcrumbs below
                    </div>
                    <div class="clearfix"></div>

                    <!-- Back and breadcrumbs -->
                    <div class="btn-toolbar dms-toolbar">
                        <div class="btn-group d-block">
                            <button
                                type="button"
                                (click)="cancel(true)"
                                class="btn btn-primary"
                            >
                                {{ modal.isSearching ? "Cancel" : "Clear" }}
                            </button>
                        </div>
                        <div class="breadcrumb-group input-group ms-2">
                            <button
                                class="btn btn-primary"
                                (click)="back(true)"
                                type="button"
                                [disabled]="modal.isTopLevel"
                            >
                                <fa-icon [icon]="faLeftArrow"></fa-icon>
                            </button>
                            <ng-container
                                *ngFor="let breadcrumb of modal.breadcrumbs"
                            >
                                <span
                                    class="btn btn-link modal-breadcrumb"
                                    (click)="
                                        setSelectedFolderPath(breadcrumb, true)
                                    "
                                >
                                    <a
                                        class="display-inline cursor-pointer underline"
                                        >{{ breadcrumb.name }}</a
                                    >
                                </span>
                                <span class="dms-slash btn btn-link">/</span>
                            </ng-container>
                        </div>
                    </div>
                    <div class="clearfix"></div>

                    <!-- Main Modal Tree -->
                    <div style="margin-left: 15px; margin-right: 15px">
                        <div
                            class="row file-tree {{ fileType }}"
                            [ngClass]="'selection-mode-' + selectionMode"
                        >
                            <div
                                class="col-xxs-12 col border-1px-solid-top-left-right border-radius-0-bottom unselectable cursor-pointer col-dms-label"
                                (click)="sortBy('label', standard.files)"
                            >
                                <div
                                    *ngIf="isMultiSelect"
                                    class="ui-chkbox display-inline"
                                    (click)="toggleSelectAll($event)"
                                >
                                    <div
                                        class="ui-chkbox-box ui-widget ui-corner-all ui-state-default"
                                    >
                                        <span
                                            class="ui-chkbox-icon ui-clickable pi"
                                            [ngClass]="{
                                                'pi-check':
                                                    (selectedFile || [])
                                                        .length ==
                                                    standard.files.length
                                            }"
                                        ></span>
                                    </div>
                                </div>
                                Name
                                <fa-icon
                                    *ngIf="showSortArrow('label')"
                                    [icon]="getSortArrowClass()"
                                ></fa-icon>
                            </div>
                            <div
                                class="col-3 hidden-xxs border-1px-solid-top-left-right border-radius-0-bottom unselectable cursor-pointer"
                                *ngIf="showColumn('modifiedBy')"
                                (click)="sortBy('modifiedBy', standard.files)"
                            >
                                Modified By
                                <fa-icon
                                    *ngIf="showSortArrow('modifiedBy')"
                                    [icon]="getSortArrowClass()"
                                ></fa-icon>
                            </div>
                        </div>
                    </div>

                    <p-tree
                        [value]="modal.folders"
                        [selectionMode]="'single'"
                        (onNodeSelect)="nodeSelect($event, false, true)"
                        [loading]="modal.showLoading"
                    >
                        <!-- Folder Template -->
                        <ng-template let-node pTemplate="Folder">
                            <div class="dms-row-container">
                                <div class="row">
                                    <div
                                        class="col-xxs-12 col-9 col-dms-label"
                                        [ngClass]="getLabelClass()"
                                    >
                                        {{ node.label }}
                                    </div>
                                    <div
                                        *ngIf="showColumn('modifiedDate')"
                                        class="col-3 hidden-xxs unselectable"
                                    >
                                        {{
                                            node.data.modifiedDate
                                                | date : "yyyy-MM-dd"
                                        }}
                                    </div>
                                </div>
                            </div>
                        </ng-template>

                        <!-- File Template -->
                        <ng-template let-node pTemplate="File">
                            <div class="dms-row-container">
                                <div class="row">
                                    <div
                                        class="col-xxs-12 col-9 col-dms-label"
                                        [ngClass]="getLabelClass()"
                                    >
                                        {{ node.label }}
                                    </div>
                                    <div
                                        *ngIf="showColumn('modifiedDate')"
                                        class="col-3 hidden-xxs unselectable"
                                    >
                                        {{
                                            node.data.modifiedDate
                                                | date : "yyyy-MM-dd"
                                        }}
                                    </div>
                                </div>
                            </div>
                        </ng-template>

                        <!-- Image Template -->
                        <ng-template let-node pTemplate="Image">
                            <div class="dms-row-container">
                                <div class="row">
                                    <div
                                        class="col-xxs-12 col-9 col-dms-label"
                                        [ngClass]="getLabelClass()"
                                    >
                                        {{ node.label }}
                                    </div>
                                    <div
                                        *ngIf="showColumn('modifiedDate')"
                                        class="col-3 hidden-xxs unselectable"
                                    >
                                        {{
                                            node.data.modifiedDate
                                                | date : "yyyy-MM-dd"
                                        }}
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </p-tree>

                    <div class="clearfix"></div>
                    <input
                        type="submit"
                        class="btn btn-primary"
                        (click)="
                            modal.isFile
                                ? renameFile(null, true)
                                : renameFolder(null, true)
                        "
                        value="Select Folder"
                    />
                </div>
            </div>
        </div>
    </div>
</div>

<div class="upload-overlay" *ngIf="showDragAndDropOverlay">
    Drop files to upload them to:<br />
    {{ dragAndDropDestination }}
</div>

<p-toast position="bottom-left" key="popup"></p-toast>
<p-toast
    position="center"
    key="confirm"
    (onClose)="toastReject()"
    [baseZIndex]="5000"
>
    <ng-template let-message pTemplate="message">
        <div class="text-center">
            <i class="pi pi-exclamation-triangle" style="font-size: 3em"></i>
            <h3>{{ message.summary }}</h3>
            <p>{{ message.detail }}</p>
        </div>
        <div class="ui-g ui-fluid">
            <div class="ui-g-6">
                <button
                    type="button"
                    pButton
                    (click)="toastConfirm(message.detail)"
                    label="Yes"
                    class="ui-button-success"
                ></button>
            </div>
            <div class="ui-g-6">
                <button
                    type="button"
                    pButton
                    (click)="toastReject()"
                    label="No"
                    class="ui-button-secondary"
                ></button>
            </div>
        </div>
    </ng-template>
</p-toast>

<!-- Rename Folder Modal -->
<div
    class="modal fade"
    id="rename-folder-modal"
    tabindex="-1"
    role="dialog"
    *ngIf="!standard.simpleView"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
>
    <div
        class="modal-dialog modal-dialog-centered modal-dialog-centered-overridden modal-lg"
        role="document"
    >
        <div class="modal-content">
            <div class="modal-header" [innerHtml]="renameModal.header"></div>
            <div class="modal-body">
                <p *ngIf="!renameModal.isNew">
                    Current {{ renameModal.node.type }} Name:
                    {{ renameModal.oldName }}
                </p>
                <input
                    class="form-control"
                    #renameModalInput
                    type="text"
                    (keypress)="characterCheck($event)"
                    [(ngModel)]="renameModal.currentName"
                    (keyup.enter)="callRenameButton()"
                />
            </div>
            <div class="modal-footer">
                <button
                    type="button"
                    data-bs-dismiss="modal"
                    class="btn btn-warning mb-0"
                    (click)="cancelRename(renameModal.isNew)"
                >
                    Cancel
                </button>
                <button
                    type="button"
                    #renameButton
                    [disabled]="renameModal.currentName === renameModal.oldName"
                    (click)="renameOrCreate($event, renameModal)"
                    data-bs-dismiss="modal"
                    class="btn btn-primary"
                >
                    OK
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Rename Folder Modal Button -->
<input
    type="button"
    #renameFolderModalButton
    data-bs-toggle="modal"
    data-bs-target="#rename-folder-modal"
    class="hidden"
/>

<!-- Rename Folder Modal -->
<div
    class="modal fade"
    id="revision-modal"
    tabindex="-1"
    role="dialog"
    *ngIf="!standard.simpleView"
>
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">Manage Revisions</div>
            <div class="modal-body">
                <p>
                    {{ revisionModal.node.type }} Name: {{ revisionModal.name }}
                </p>
                <hr />
                <div
                    class="repeater-loading loading-overlay spinner"
                    *ngIf="revisionModal.loading"
                >
                    <div class="loader"></div>
                </div>
                <div
                    *ngIf="!revisionModal.loading"
                    class="revision-modal-scrollable"
                >
                    <div
                        *ngFor="
                            let version of revisionModal.versions;
                            let j = index
                        "
                        class="version-repeater"
                    >
                        <i class="fa fa-file-image"></i>
                        <div class="version-repeater-body">
                            <span class="version-repeater-header">{{
                                j == 0
                                    ? "Current Revision"
                                    : "Revision " +
                                      (revisionModal.versions.length - j - 1)
                            }}</span
                            ><br />
                            <span class="version-repeater-date">{{
                                version.lastModified | date : "yyyy-MM-dd"
                            }}</span>
                            by
                            <span class="version-repeater-modified-by">{{
                                version.modifiedBy
                            }}</span
                            ><br />
                            Size:
                            <span class="version-repeater-size"
                                >{{ getSize(version.size) | number : "1.0-2" }}
                                {{ getSizeMetric(version.size) }}</span
                            >
                        </div>
                        <div class="version-repeater-options">
                            <div
                                class="btn-group dropleft"
                                id="revision-menu-{{ j }}"
                            >
                                <button
                                    class="btn btn-link"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-haspopup="true"
                                >
                                    <span class="dot"></span>
                                    <span class="dot"></span>
                                    <span class="dot"></span>
                                </button>
                                <div class="dropdown-menu">
                                    <input
                                        type="button"
                                        class="dropdown-item btn btn-link"
                                        value="Download"
                                        (click)="
                                            downloadFileVersion(
                                                revisionModal.node.data.url,
                                                version.versionId,
                                                'revision-menu-' + j
                                            )
                                        "
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button
                    type="button"
                    data-bs-dismiss="modal"
                    class="btn btn-primary"
                >
                    OK
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Rename Folder Modal Button -->
<input
    type="button"
    #revisionModalButton
    data-bs-toggle="modal"
    data-bs-target="#revision-modal"
    class="hidden"
/>
